import React from "react";
import "./PlayerInformation.css";
import "./Team.css";
import { team_css_class_map } from "../../../../utils/utils";
import { connect } from "react-redux";
import { setTeamNameOfSelectedPlayer } from "../../../../redux";
import Badge from "@material-ui/core/Badge/Badge";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import CustomBadgeSubstitute from "./CustomBadgeSubstitute";
import CustomBadgeUnannounced from "./CustomBadgeUnannounced";
import {
  API_CONSTANTS,
  INJURY_STATUS,
  OPERATOR_STATUS,
  TOSS_EVENT,
} from "../../../../utils/constantInformation";
import ImageWithBadges from "./ImageWithBadges";

const theme = createTheme({
  palette: {
    primary: green,
    secondary: { main: "#6C757D" },
  },
  customBadge: {
    backgroundColor: "#00AFD7",
    color: "#8863CC",
  },
});

const PlayerInformationBadge = ({ props }) => {
  const { OperatorMatchInfo, Team, ImageURL, Toss, InjuryStatus } =
    props.player_information_props;

  // Determine badge settings based on conditions
  const badgeSettings = () => {
    const baseSettings = {
      imageUrl: ImageURL,
      styling: `playerinformation-image ${team_css_class_map[props.player_information_props.Team]
        } align-items-center player_image`,
      metadata: props,
      topRight: null,
      bottomRight: null,
      topLeft: null,
    };
    // console.log(
    //   "badgeSettings: OperatorMatchInfo",
    //   props.player_information_props.OperatorPlayerID,
    //   props.player_information_props
    // );

    switch (props.player_information_props.OperatorMatchInfo) {
      case OPERATOR_STATUS.ANNOUNCED:
      case OPERATOR_STATUS.ANNOUNCED_SUB:
        return {
          ...baseSettings,
          topRight: { color: "primary", variant: "dot" },
        };
      case OPERATOR_STATUS.SUBSTITUTE:
        return <CustomBadgeSubstitute variant="dot" props={props} />;
      case OPERATOR_STATUS.UNANNOUNCED:
        return <CustomBadgeUnannounced variant="dot" props={props} />;
      case OPERATOR_STATUS.PLAYED_LAST_MATCH:
      case OPERATOR_STATUS.PLAYED_LAST_MATCH_SUB_IN:
      case OPERATOR_STATUS.PLAYED_LAST_MATCH_SUB_OUT:
      default:
        // console.log(
        //   "default case",
        //   props.player_information_props.OperatorPlayerID,
        //   props.player_information_props
        // );
        const isOut =
          props.player_information_props.Toss === TOSS_EVENT.NOT_HAPPENED &&
          props.player_information_props.InjuryStatus === INJURY_STATUS.OUT;
        const isQuestionable =
          props.player_information_props.Toss === TOSS_EVENT.NOT_HAPPENED &&
          props.player_information_props.InjuryStatus ==
          INJURY_STATUS.QUESTIONABLE;
        const arrowIcon =
          props.player_information_props.OperatorMatchInfo ===
            OPERATOR_STATUS.PLAYED_LAST_MATCH_SUB_OUT ? (
            <ArrowForward
              style={{
                background: "transparent",
                color: "red",
                marginLeft: "8px",
              }}
            />
          ) : (
            <ArrowBack
              style={{
                background: "transparent",
                color: "green",
                marginLeft: "8px",
              }}
            />
          );
        const isLastMatchPlayed =
          props.player_information_props.OperatorMatchInfo &&
          props.player_information_props.OperatorMatchInfo.toLowerCase().includes(
            "played last match"
          );
        // console.log(
        //   "player id",
        //   props.player_information_props.OperatorPlayerID,
        //   "isOut",
        //   isOut,
        //   "isQuestionable",
        //   isQuestionable,
        //   "isLastMatchPlayed",
        //   isLastMatchPlayed
        // );
        return {
          ...baseSettings,

          topRight: isLastMatchPlayed
            ? { color: "secondary", badgeContent: "LP" }
            : null,
          topLeft: isOut
            ? { color: "error", badgeContent: "O" }
            : isQuestionable
              ? {
                badgeContent: "Q",
              }
              : null,
          bottomRight:
            props.player_information_props.OperatorMatchInfo &&
              props.player_information_props.OperatorMatchInfo.toLowerCase().includes(
                "sub"
              )
              ? {
                badgeContent: arrowIcon,
                variant: "default",
              }
              : null,
        };
    }
  };

  const renderBadgeContent = (settings) => {
    if (React.isValidElement(settings)) {
      // console.log("basic settings", settings);
      // If settings is a React element (custom badge components), return it directly
      return settings;
    }

    // Otherwise, return ImageWithBadges with dynamically determined props
    // console.log("dynamic settings", settings);
    return (
      <ImageWithBadges
        imageUrl={settings.imageUrl}
        styling={settings.styling}
        metadata={settings.metadata}
        topRight={settings.topRight}
        bottomRight={settings.bottomRight}
        topLeft={settings.topLeft}
      />
    );
  };

  return renderBadgeContent(badgeSettings());
};

function PlayerInformation(props) {
  const [datetime, setDateTime] = React.useState(null);

  React.useEffect(async () => {
    console.log("");

    const date = new Date(props.player_information_props["GameDateTime"]);
    let datetimestring =
      date.toDateString().split(" ")[0].toUpperCase() +
      " " +
      date.toLocaleTimeString().replace(":00", "");
    setDateTime(datetimestring);
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="d-flex p-2" style={{ background: "#000000" }}>
        <div className="d-flex p-2 align-items-center justify-content-center">
          <PlayerInformationBadge props={props} />

          <div className="m-0 align-self-center align-items-center pl-5 name_div ">
            <h4 className="m-0 p-0">
              <span className="text-white player_name">
                {props.player_information_props.OperatorPlayerName}{" "}
              </span>
              <span>
                <small>
                  <small className="text-primary font-weight-bold player_position">
                    {props.player_information_props.Position}
                  </small>
                </small>
              </span>
            </h4>
            {/* </Badge> */}
            <p className="text-secondary m-0 p-0 team_vs_team">
              {props.player_information_props.Team} vs{" "}
              {props.player_information_props.Opponent}
            </p>
            <p className="text-secondary m-0 p-0 date_time">{datetime}</p>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
const mapStateToProps = (state) => {
  return {
    player_information: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    teamname_setter: (value) => dispatch(setTeamNameOfSelectedPlayer(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayerInformation);
